import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " The script must be written using Groovy or Javascript languages. ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The script must return an XML string containing a list of values with the syntax shown below. If the script instead returns a single value this is automatically enveloped in such XML. <ROWS>"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW value=\"value1\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW value=\"value2\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ..."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" </ROWS> ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Scripts can be parametrized with profile attributes, called with syntax ${name_attribute}; these can have a sinle or a multi value:", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("A profile multi-value attribute is registered in authorization.xml file, and its value is written with syntax: "),
  /*#__PURE__*/_createVNode("i", null, "{splitter {value_1 splitter value_2 splitter ... value_n}};")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "For groovy and javascript scripts some functions are added by system that let user to include a value in XML string and to treat multi-values attribute:", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "returnValue(value_to_return)"),
  /*#__PURE__*/_createTextVNode(": Returns the value with the following syntax")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" <ROWS>")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" <ROW value=\"valueAttribute1\" />")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" </ROWS> ")
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "getListFromMultiValueProfileAttribute(String nameAttribute)"),
  /*#__PURE__*/_createTextVNode(": Returns list of values of a multi value profile attribute with following syntax (parameter must be enclosed between \"\") <ROWS>"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW value=\"value1\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW value=\"value2\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ..."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" </ROWS> ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Example:"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("i", null, "getListFromMultiValueProfileAttribute(\"${multi_value_attribute}\")")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "getMultiValueProfileAttribute(String nameAttribute, String prefix, String newSplitter, String suffix)"),
  /*#__PURE__*/_createTextVNode(" : Return list f values of multi value attribute, preceded by the prefix, separated by the new splitter and followed by suffix (parameter must be enclosed between \"\")"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("b", null, "Example:"),
  /*#__PURE__*/_createTextVNode(" select ... where "),
  /*#__PURE__*/_createVNode("i", null, " column ${multi_value_attribute( \"in (\" ; \",\" ; \") \") })")
], -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Column names with dots or aggregator functions are not allowed, if you need them use alias (as)."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("b", null, "Example:"),
  /*#__PURE__*/_createTextVNode(" select sum(column) as name_colum, select column.column as name_column ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To use a single value profile attribute into the query use "),
  /*#__PURE__*/_createVNode("b", null, "${name_profile_attribute}"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("b", null, "Example:"),
  /*#__PURE__*/_createTextVNode(" select ... where column = '${name_profile_attribute}'). ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To use a multi value profile attribute use "),
  /*#__PURE__*/_createVNode("b", null, "${name_profile_attribute(prefix;splitter;suffix)}"),
  /*#__PURE__*/_createTextVNode(" The profile attribute will be replaced by prefix+(list of values separated by the splitter)+suffix."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("b", null, "Example:"),
  /*#__PURE__*/_createTextVNode(" select ... where column ${name_profile_attribute( in (';',';') )}) ")
], -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("To insert a single value profile attribute into a fix lov value use "),
  /*#__PURE__*/_createVNode("b", null, "${name_profile_attribute}"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" To insert a multi value profile attribute into a fix lov value use ")
const _hoisted_25 = /*#__PURE__*/_createVNode("b", null, "${name_profile_attribute(prefix;splitter;suffix)}", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" The profile attribute will be replaced by prefix+(list of values separated by the splitter)+suffix")
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("b", null, "Example:", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" ${name_profile_attribute( in (';',';') )} ")
const _hoisted_32 = { key: 3 }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, " The java class must implement the interface it.eng.spagobi.bo.javaClassLovs.IJavaClassLov. This interface has two methods: getValues(IEngUserProfile profile): the method returns an xml string containing the list of values. The xml string must be formatted using the xml structure reported below getNamesOfProfileAttributeRequired(): the method returns a java list containing the names of profile attributes used by the class. If the class doesn't use profile attributes simply returns an empty list. ", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Xml structure of the returned string")
], -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" <ROWS>"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW nameAttribute1=\"valueAttribute1\" nameAttribute2=\"valueAttribute2\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" <ROW nameAttribute1=\"valueAttribute1\" nameAttribute2=\"valueAttribute2\" ... />"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ..."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" All the rows must have the same attributes !"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ..."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" </ROWS> ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.lovsManagementInfoDialogDescriptor.dialog.style,
    header: _ctx.infoTitle,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.lovType === _ctx.lovItemEnum.SCRIPT)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17
          ]))
        : (_ctx.lovType === _ctx.lovItemEnum.QUERY)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ]))
          : (_ctx.lovType === _ctx.lovItemEnum.FIX_LOV)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _hoisted_31
              ]))
            : (_ctx.lovType === _ctx.lovItemEnum.JAVA_CLASS)
              ? (_openBlock(), _createBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _hoisted_34,
                  _hoisted_35,
                  _hoisted_36,
                  _hoisted_37
                ]))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "header", "visible"]))
}